'use strict';

angular.module('shiftTraderApp')
  .directive('saWideWorkPeriodView', function () {
    return {
      templateUrl: 'views/directives/saWideWorkPeriodView.html',
      restrict: 'A',
      scope: {},
      controller: ['$scope', 'saViewShiftHourWidthInt', '$timeout', 'Session', 'PositioningService', 'EventStreamsService', function($scope, saViewShiftHourWidthInt, $timeout, Session, PositioningService, EventStreamsService) {
        var mwpCollapseStream = EventStreamsService.getStream(EventStreamsService.names.mwpCollapseChange);
        var barIntervalUpdateStream = EventStreamsService.getStream(EventStreamsService.names.barIntervalUpdates);
        var disposableSubscriptions = [];

        $scope.mwpController = $scope.$parent;
        $scope.measuringTapeInfo = $scope.mwpController.measuringTapeInfo;
        $scope.departments = $scope.mwpController.allDepartments;
        $scope.currentDate = $scope.mwpController.currentDate;

        var calculateDepartmentBarWorkIntervalTimeouts = {};
        var initDepartmentStatsDataStructures = function() {
          $scope.departmentsStatsData = {};

          lodash.forEach($scope.departments, function(dept) {
            calculateDepartmentBarWorkIntervalTimeouts[dept.id] = null;
            $scope.departmentsStatsData[dept.id] = {
              rawPositionIntervalData: {},
              processedData: {}
            };

            lodash.forEach(dept.positionsToShow, function(pos) {
              $scope.departmentsStatsData[dept.id].rawPositionIntervalData[pos.id] = [];
            });
          });
        };

        initDepartmentStatsDataStructures();

        var calculateWholeOrgBarWorkIntervalTimeout = null;
        var initWholeOrgStatsDataStructures = function() {
          $scope.wholeOrgStatsData = {
            rawDepartmentIntervalData: {},
            processedData: {}
          };

          lodash.forEach($scope.departments, function(dept) {
            $scope.wholeOrgStatsData.rawDepartmentIntervalData[dept.id] = [];
          });
        };

        initWholeOrgStatsDataStructures();

        $scope.clickedOnPositionBar = function(pos, $event) {
          if (pos._collapsed) {
            pos.toggleCollapsedProperty();
            mwpCollapseStream.push('position', pos.id);
            $event.stopPropagation();
          }
        };

        this.getWorkPeriodsOfTheDay = function() {
          return $scope.mwpController.workPeriodsOfTheDay;
        };

        this.getSelectedTemplate = function() {
          return $scope.mwpController.state.selectedTemplate;
        };

        this.getCurrentDate = function() {
          return $scope.currentDate;
        };

        this.getAllShifts = function() {
          return $scope.mwpController.state.selectedTemplate.shifts;
        };

        this.getRawPermissions = function() {
          return $scope.mwpController.getRawPermissions();
        };

        this.getOrg = function() {
          return $scope.mwpController.org;
        };

        var initNewDate = function() {
          var startOfDayTime = moment($scope.currentDate).subtract(6,'hours');//.unix();
          var endOfDayTime = moment($scope.currentDate).add(30, 'hours');//.unix();
          $scope.currentViewWindow = startOfDayTime.twix(endOfDayTime);
          $scope.currentViewWindowLength = $scope.currentViewWindow.length('minutes');
          initDepartmentStatsDataStructures();
          lodash.forEach($scope.departments, function(dept) {
            calculateDepartmentBarWorkIntervals(dept.id);
          });
        };

        // all subsequent date changes will be processed via events sent from MWP once proper data has been returned
        $scope.$on('sa:wideWorkPeriodView:dateChange', function(evt, newDate) {
          // console.log('sa:wideWorkPeriodView:dateChange', newDate.format());
          $scope.currentDate = newDate;
          initNewDate();
        });

        lodash.forEach(['reloadingPositionBar', 'departmentCollapseStateChange'], function(eventName) {
          $scope.$on(eventName, function(event) {
            if (event.stopPropagation) {
              event.stopPropagation();
            }
            debouncedUpdateLineLengths();
          });
        });

        var departmentEndpointCalc = function(collection) {
          return lodash(collection).map(function(intervals) {
            return lodash.map(intervals, 'interval');
          }).flattenDeep().uniq().sortBy().value();
        };

        var departmentTestFn = function(dikt, collection) {
          var testPoint = dikt.interval[0] + 1;
          lodash.forEach(collection, function(intervals) {
            lodash.forEach(intervals, function(point) {
              // in the case that the interval that we have for a position starts after our interval of interest, break out of the loop
              if (point.interval[0] >= dikt.interval[1]) {
                return false;
              }

              // evaluate the count at a test point
              if (point.interval[0] <= testPoint && point.interval[1] >= testPoint) {
                dikt.count += point.count;
              }
            });
          })
        };

        var departmentStyleFn = function(dikt, idx, previousDikt, maxCount) {
          if (idx > 0 && dikt.count > 0 && previousDikt.count > 0) {
            dikt.styling['border-left'] = 'none';
          }
          dikt.styling['background-color'] = 'rgba(255,144,53,' + (Math.pow(2, 0.92 * (dikt.count / maxCount)) - 0.9) + ')';

          dikt.uniqueId = dikt.styling.left + '-' + dikt.styling.width + '-' + dikt.count;
        };

        var calculateDepartmentBarWorkIntervals = function(department_id) {
          var targetDeptData = $scope.departmentsStatsData[department_id];
          $scope.departmentsStatsData[department_id].processedData =
              lodash.filter(PositioningService.calcWorkIntervals(targetDeptData.rawPositionIntervalData,
                  $scope.currentViewWindow,
                  departmentEndpointCalc, departmentTestFn, departmentStyleFn),
              function(x) {
                return x.count > 0;
              });
        };

        var wholeOrgStyleFn = function(dikt, idx, previousDikt, maxCount) {
          if (idx > 0 && dikt.count > 0 && previousDikt.count > 0) {
            dikt.styling['border-left'] = 'none';
          }
          //dikt.styling['background-color'] = 'rgba(0,179,181,' + (Math.pow(2, 0.92 * (dikt.count / maxCount)) - 0.9) + ')';
          dikt.styling['background-color'] = 'rgba(236,115,100,' + (Math.pow(2, 0.92 * (dikt.count / maxCount)) - 0.9) + ')';

          dikt.uniqueId = dikt.styling.left + '-' + dikt.styling.width + '-' + dikt.count;
        };

        var calculateWholeStoreBarWorkIntervals = function() {
          $scope.wholeOrgStatsData.processedData =
            lodash.filter(PositioningService.calcWorkIntervals($scope.wholeOrgStatsData.rawDepartmentIntervalData,
                $scope.currentViewWindow,
                departmentEndpointCalc, departmentTestFn, wholeOrgStyleFn),
              function(x) {
                return x.count > 0;
              });
        };

        disposableSubscriptions.push(barIntervalUpdateStream.filterByType('positionUpdate')
          .subscribe(function(update) {
            // window.logTime('positionUpdate seen from Position: ' + update.data.position_id);

            // add this IF just to guard things.
            if ($scope.departmentsStatsData[update.data.department_id] &&
              $scope.departmentsStatsData[update.data.department_id].rawPositionIntervalData &&
              $scope.departmentsStatsData[update.data.department_id].rawPositionIntervalData[update.data.position_id]) {

              $scope.departmentsStatsData[update.data.department_id].rawPositionIntervalData[update.data.position_id] = update.data.intervals;

              // cancel the department timeout if it's already running
              if (!lodash.isNull(calculateDepartmentBarWorkIntervalTimeouts[update.data.department_id])) {
                $timeout.cancel(calculateDepartmentBarWorkIntervalTimeouts[update.data.department_id]);
              }

              calculateDepartmentBarWorkIntervalTimeouts[update.data.department_id] = $timeout(
                function() {
                  // window.logTime('calculating for department_id: ', update.data.department_id);
                  calculateDepartmentBarWorkIntervals(update.data.department_id);
                  $scope.wholeOrgStatsData.rawDepartmentIntervalData[update.data.department_id] = $scope.departmentsStatsData[update.data.department_id].processedData;

                  if (!lodash.isNull(calculateWholeOrgBarWorkIntervalTimeout)) {
                    $timeout.cancel(calculateWholeOrgBarWorkIntervalTimeout);
                  }
                  calculateWholeOrgBarWorkIntervalTimeout = $timeout(
                    function() {
                      // window.logTime('calculating for whole store');
                      calculateWholeStoreBarWorkIntervals();
                    }, 250);
                }, 500
              );

            }
          }));

        var updateLineLengths = function() {
          $scope.numberOfLinesToDisplay = lodash($scope.departments).map(function(dept) {
            if (dept._collapsed) {
              return 16;
            } else {
              return lodash(dept.positionsToShow).map(function(pos) {
                return pos._height;
              })
              .reduce(function(y, z) { return y + z; }, 0) + 16;
            }
          }).reduce(function(y,z) {
            return y + z;
          }, 0) + 20;

          $('.measuring-tape-tick-hours').css('height', $scope.numberOfLinesToDisplay);
          $('.measuring-tape-day-divider').css('height', $scope.numberOfLinesToDisplay);
        };

        var debouncedUpdateLineLengths = lodash.debounce(updateLineLengths, 100);

        $scope.leftStartOfDayInPx = (6 + Session.getWorkDayStartHour() ) * saViewShiftHourWidthInt + 'px';
        $scope.leftEndOfDayInPx = (6 + 24 + Session.getWorkDayStartHour() ) * saViewShiftHourWidthInt + 'px';

        // need to call it to process the initial state of $scope.currentDate
        initNewDate();

        $scope.$on('$destroy', function() {
          lodash.invoke(disposableSubscriptions, 'dispose');
        });
      }]
    };
  });
